import React from 'react';
import { Card, Field, TextField, SaveButton, useSection } from '../AdminUI';
import { Switch } from '../../ui/switch';
import { Plus, Trash2 } from 'lucide-react';
import MediaUpload from '../MediaUpload';

const EMPTY = { enabled: true, title: 'PAYMENT WE ACCEPT', logos: [] };

export default function PaymentsWeAcceptSection() {
  const [raw, setLocal, save] = useSection('paymentsWeAccept');
  const local = raw || EMPTY;
  const set = (k, v) => setLocal({ ...local, [k]: v });
  const setLogo = (i, patch) => set('logos', local.logos.map((l, idx) => idx === i ? { ...l, ...patch } : l));
  const addLogo = () => set('logos', [...(local.logos || []), { id: `pay_${Date.now()}`, label: '', image: '' }]);
  const rmLogo = (i) => set('logos', local.logos.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const arr = [...local.logos];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    set('logos', arr);
  };

  return (
    <div data-testid="payments-we-accept-admin">
      <Card
        title="Section Visibility"
        desc="Turn the Payments We Accept strip on/off on the site."
        footer={<SaveButton onClick={save} />}
      >
        <div className="flex items-center gap-3">
          <Switch checked={local.enabled !== false} onCheckedChange={(v) => set('enabled', v)} data-testid="payments-enabled-toggle" />
          <span className="text-sm text-zinc-400">{local.enabled !== false ? 'Section is visible' : 'Section is hidden'}</span>
        </div>
      </Card>

      <Card
        title="Payments We Accept"
        desc="Upload payment provider logos (PhonePe, GPay, Paytm, Bank IMPS, etc.). Users see them in a horizontal strip."
        footer={<SaveButton onClick={save} />}
      >
        <div className="mb-5">
          <Field label="Section Title">
            <TextField value={local.title || ''} onChange={(v) => set('title', v)} data-testid="payments-title" />
          </Field>
        </div>

        <div className="space-y-3">
          {(local.logos || []).map((l, i) => (
            <div key={l.id || i} className="rounded border border-zinc-800 bg-zinc-950/60 p-3" data-testid={`payment-logo-row-${i}`}>
              <div className="grid grid-cols-1 md:grid-cols-[220px_1fr_44px_44px_44px] items-center gap-3">
                <MediaUpload
                  value={l.image}
                  onChange={(v) => setLogo(i, { image: v })}
                  accept="image"
                  previewClass="h-14 w-32"
                  testid={`payment-logo-${i}`}
                />
                <TextField value={l.label || ''} onChange={(v) => setLogo(i, { label: v })} placeholder="Label (fallback if no image)" />
                <button onClick={() => move(i, -1)} className="h-9 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 hover:text-white text-xs" title="Move up">↑</button>
                <button onClick={() => move(i, +1)} className="h-9 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 hover:text-white text-xs" title="Move down">↓</button>
                <button onClick={() => rmLogo(i)} className="h-9 rounded-md bg-zinc-950 border border-zinc-800 text-red-400 hover:bg-red-600 hover:text-white flex items-center justify-center" title="Remove">
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
          ))}
          <button onClick={addLogo} className="w-full h-10 rounded-md border border-dashed border-zinc-700 hover:border-[color:var(--gold)]/50 text-zinc-300 text-sm font-semibold flex items-center justify-center gap-1.5" data-testid="payments-add-logo">
            <Plus size={14} /> Add Payment Logo
          </button>
        </div>
      </Card>
    </div>
  );
}
